module.exports = __webpack_public_path__ + "moonhouse.48419a412ae68ffb881d.ttf";


//////////////////
// WEBPACK FOOTER
// C:/angular/glow/src/assets/fonts/moonhouse.ttf
// module id = ../../../../../src/assets/fonts/moonhouse.ttf
// module chunks = styles